/* eslint-disable no-alert */
import Api from '../api';

interface CreateMonitoreBiddingParams {
  biddingId: number;
  companyId: number;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setMonitored: React.Dispatch<React.SetStateAction<boolean>>;
}

interface DestroyMonitoredBiddingParams {
  biddingId: number;
  companyId: number;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setMonitored: React.Dispatch<React.SetStateAction<boolean>>;
}

export const createMonitoreBidding = async (params: CreateMonitoreBiddingParams) => {
  const { biddingId, setIsLoading, setMonitored, companyId } = params;
  setIsLoading(true);
  try {
    const response = await Api.post('/facilitadores/monitoramento', {
      bidding_id: biddingId,
      companyId,
    });

    setIsLoading(false);

    if (response?.status === 201) {
      setMonitored(true);
    }

    if (response?.status === 401) {
      alert(response?.data?.error?.[0] || 'Ação não autorizada.');
      return null;
    }

    return response.data;
  } catch (error: any) {
    setIsLoading(false);
    const errorMessage =
      error?.response?.data?.error?.[0] || 'Erro ao ativar monitoramento. Tente novamente.';
    alert(errorMessage);
    return null;
  }
};

export const destroyMonitoredBidding = async (params: DestroyMonitoredBiddingParams) => {
  const { biddingId, companyId, setIsLoading, setMonitored } = params;
  setIsLoading(true);
  const response = await Api.delete(`/facilitadores/monitoramento/${biddingId}`, {
    params: { companyId },
  });
  setIsLoading(false);

  if (response?.status === 200) setMonitored(false);

  return response.data;
};

export const access_tool_overview = async () => {
  const response = await Api.get('/gerenciar_licitacoes/gerenciar/access_tool_overview');
  return response.data.access;
};
